import { getYmapsRefererHint } from "./ymapsRefererHint";

let loadPromise = null;

function resetLoadPromise() {
  loadPromise = null;
}

function removeYmapsScriptTags() {
  document
    .querySelectorAll('script[src*="api-maps.yandex.ru/v3/"]')
    .forEach((node) => node.remove());
}

function logYmapsScriptError(apiKey) {
  if (process.env.NODE_ENV !== "development") {
    return;
  }
  const prefix = apiKey.slice(0, 8);
  const host =
    typeof window !== "undefined" ? window.location.hostname : "unknown";
  console.error(
    `[Yandex Maps] script load failed (403). Key prefix: ${prefix}… Page host: ${host}.` +
      getYmapsRefererHint() +
      " Check Network → api-maps.yandex.ru/v3: status 403 and whether Request Headers has Referer." +
      " Cabinet Referer must be saved as: localhost / 127.0.0.1 / dmc-mact.ru (no http://).",
  );
}

function waitForYmaps3Ready() {
  if (!window.ymaps3) {
    return Promise.reject(new Error("YMAPS3_MISSING"));
  }
  return window.ymaps3.ready;
}

function injectYmapsScript(apiKey) {
  return new Promise((resolve, reject) => {
    removeYmapsScriptTags();
    const script = document.createElement("script");
    script.src = `https://api-maps.yandex.ru/v3/?apikey=${encodeURIComponent(apiKey)}&lang=ru_RU`;
    script.async = true;
    script.referrerPolicy = "origin";
    script.onload = () => {
      waitForYmaps3Ready().then(resolve).catch((readyError) => {
        if (process.env.NODE_ENV === "development") {
          console.error("[Yandex Maps] ymaps3.ready failed:", readyError);
        }
        reject(new Error("YMAPS3_READY_FAILED"));
      });
    };
    script.onerror = () => {
      logYmapsScriptError(apiKey);
      reject(new Error("SCRIPT_LOAD_FAILED"));
    };
    document.head.appendChild(script);
  });
}

export function loadYmaps3() {
  const apiKey = process.env.REACT_APP_YANDEX_MAPS_API_KEY?.trim();
  if (!apiKey) {
    return Promise.reject(new Error("NO_API_KEY"));
  }

  if (window.ymaps3) {
    return window.ymaps3.ready;
  }

  if (!loadPromise) {
    loadPromise = injectYmapsScript(apiKey).catch((error) => {
      resetLoadPromise();
      throw error;
    });
  }

  return loadPromise;
}
